/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloudStateInProgressIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Cloud State In Progress',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M7.7998,17H3.71777c-1.90332,0-3.45215-1.54785-3.45215-3.45117,0-1.49219.9668-2.78027,2.32422-3.25-.04297-.23145-.06445-.46582-.06445-.70312,0-2.17969,1.80957-3.95215,4.0332-3.95215.2793,0,.55762.0293.83105.08789.6377-1.95898,2.47656-3.34766,4.58887-3.34766,2.49609,0,4.56738,1.87012,4.81836,4.35059.04199.41211-.25879.7793-.6709.82129-.40527.04785-.7793-.25879-.82129-.6709-.17285-1.71094-1.60352-3.00098-3.32617-3.00098-1.66309,0-3.08008,1.25195-3.29688,2.91211-.03125.23535-.17188.44238-.37891.55762-.20898.11719-.45801.125-.6748.02832-.34863-.1582-.70898-.23828-1.06934-.23828-1.39648,0-2.5332,1.09961-2.5332,2.45215,0,.33203.06934.65625.20605.96484.09961.22363.08301.48242-.04395.69238s-.34863.34375-.59375.35938c-1.02539.06641-1.82812.91699-1.82812,1.93652,0,1.07617.87598,1.95117,1.95215,1.95117h4.08203c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="M19.3623,9.8916c-.32812-.0791-.67285.125-.75391.46094l-.07495.31006c-.84961-1.0484-2.1377-1.69775-3.53345-1.69775-1.95312,0-3.68652,1.24414-4.3125,3.09668-.13281.39258.07715.81836.46973.9502.0791.02734.16016.04004.24023.04004.3125,0,.60449-.19727.70996-.50977.4209-1.24219,1.58301-2.07715,2.89258-2.07715.94873,0,1.82422.44586,2.39343,1.16602l-.62976-.15234c-.33008-.0791-.67285.125-.75391.46094-.08105.33496.125.67285.46094.75391l2.09277.50586c.04883.01172.09863.01758.14746.01758.28125,0,.53711-.19238.60645-.47852l.50586-2.09277c.08105-.33496-.125-.67285-.46094-.75391Z"
      fill="currentColor"
    />
    <path
      d="M18.84082,14.03613c-.39355-.13477-.81836.07617-.95117.46875-.4209,1.23926-1.58203,2.07227-2.88965,2.07227-.96191,0-1.82703-.44556-2.39185-1.16565l.62817.15198c.33203.08105.67285-.125.75391-.46094.08105-.33496-.125-.67285-.46094-.75391l-2.09277-.50586c-.33008-.08008-.67285.125-.75391.46094l-.02881.1189c-.0144.04993-.03247.09753-.03625.15015l-.4408,1.82373c-.08105.33496.125.67285.46094.75391.04883.01172.09863.01758.14746.01758.28125,0,.53711-.19238.60645-.47852l.07495-.30957c.84314,1.04883,2.11755,1.69727,3.53345,1.69727,1.9502,0,3.68164-1.24219,4.30957-3.08984.13379-.39258-.07617-.81836-.46875-.95117Z"
      fill="currentColor"
    />
  </svg>`;
};
